module.exports = __webpack_public_path__ + "static/img/photo9.d90088fe.jpg";